export class ZipCodeIntegration {
  private zipCode: string;
  private address: string;
  private neighborhood: string;
  private locality: string;
  private stateCode: string;

  public getZipCode(): string {
    return this.zipCode;
  }
  public setZipCode(zipCode: string): void {
    this.zipCode = zipCode;
  }
  public getAddress(): string {
    return this.address;
  }
  public setAddress(address: string): void {
    this.address = address;
  }
  public getNeighborhood(): string {
    return this.neighborhood;
  }
  public setNeighborhood(neighborhood: string): void {
    this.neighborhood = neighborhood;
  }
  public getLocality(): string {
    return this.locality;
  }
  public setLocality(locality: string): void {
    this.locality = locality;
  }
  public getStateCode(): string {
    return this.stateCode;
  }
  public setStateCode(stateCode: string): void {
    this.stateCode = stateCode;
  }
}
